import styles from './loan.module.scss';
import { CheckboxLabel, TextField } from '@frontend-workspace/react-shared-lib';
import { dateFormatter, getTimezone } from 'libs/webkua-lib/src/lib/helpers';
import { ILoan } from 'libs/webkua-lib/src/lib/_models/loan';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface LoanProps {
  loan?: ILoan
}

export function Loan(props: LoanProps) {
  const { t } = useTranslation();

  return (
    <Row>
      <Col md={6} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={props.loan?.id || ''}
            fullWidth
            label={t("standard.loanID")}
            disabled
            className='mb-3'
          />
          <TextField
            value={dateFormatter(props.loan?.createdTime)}
            fullWidth
            label={t("standard.created")}
            disabled
            className='mb-3'
          />
          <TextField
            value={dateFormatter(props.loan?.expirationTime)}
            fullWidth
            label={t("standard.expires")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={6} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value={dateFormatter(props.loan?.lastRenewedTime)}
            fullWidth
            label={t("standard.lastRenewed")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.logOnDuration || ''}
            fullWidth
            label={t("loan.logOnDuration")}
            disabled
            className='mb-3'
          />
          <TextField
            value={getTimezone(props.loan?.utcOffset || 0)}
            fullWidth
            label={t("loan.timeZone")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={6} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <TextField
            value='Mangler data'
            fullWidth
            label={t("standard.returnType")}
            disabled
            className='mb-3'
          />
          <TextField
            value={props.loan?.userIdReleased || 'Ikke frigjort'}
            fullWidth
            label={t("standard.releasedBy")}
            disabled
            className='mb-3'
          />
          <TextField
            value={dateFormatter(props.loan?.returnedTime)}
            fullWidth
            label={t("standard.returned")}
            disabled
            className='mb-3'
          />
        </div>
      </Col>
      <Col md={6} xxl={3}>
        <div className="d-flex flex-column mb-3">
          <CheckboxLabel
            label={t("standard.borrowed")}
            checked={props.loan?.isBorrowed}
            disabled={true}
          />
          <CheckboxLabel
            label={t("standard.offline")}
            checked={props.loan?.isOffline}
            disabled={true}
          />
          <CheckboxLabel
            label={t("loan.newDevice")}
            checked={props.loan?.isDeviceChanged}
            disabled={true}
          />
        </div>
      </Col>
    </Row>
  );
}

export default Loan;